import { RadioButtonGroup } from 'app-principal-componentes-visuales';
import React, { useEffect, useState } from 'react'
import { formatDirection } from '../../../utils/ubicacionUtils';
import './DatosUbicacion.scss'
import { capitalizeString, capitalizeWord } from '../../../utils/utils';
import { Direccion } from '../../../interfaces/direccion.interface';
import { CALLE_INTERNA } from '../../../utils/constants';

const DatosUbicacion = ({ direcciones, onEditarDireccion, openDeleteDirection, returnSelectedDirection, setSelectedOption } : {[ key: string ]: any }) => {

    const [selected, setSelected] = useState('');
    const [direccionesList, setDireccionesList] = useState([]);

    useEffect(() => {
        direcciones.forEach((direccion, index) => {
            if(direccion.seleccionado) {
                setSelected(index.toString());
                setSelectedOption(direccion);
            }
        });

        let direccionesRadioButton = [];
        direcciones.forEach((direccion:Direccion, index) => {
            let direccionAux = {
                address: capitalizeString(formatDirection(direccion)),
                nota: <>{
                        capitalizeString(direccion.localidad)
                    } <br/> {
                        capitalizeWord(
                            direccion?.barrioCerrado ? 
                            direccion?.observaciones?.split(`${CALLE_INTERNA}:`)?.[1]?.split(`-`)?.[0] ?? '' : 
                            direccion?.observaciones?.trim() ?? ''
                        )} </>,
                onClick: () => { handleSelected(index) },
                onClickEditar: () => { handleEdit(index) },
                onClickEliminar: () => { handleDelete(index) },
                value: (index.toString())
            }
            direccionesRadioButton.push(direccionAux);
        });
        setDireccionesList(direccionesRadioButton);
    }, [direcciones.length, direcciones])

    const handleEdit = (index) => {
        let selectedDirection = direcciones[index];
        onEditarDireccion(selectedDirection)  
    }

    const handleDelete = (index) => {
        let selectedDirection = direcciones[index];
        openDeleteDirection(selectedDirection, 'ubicaciones')
    }

    const handleSelected = (index) => {
        setSelected(index.toString());
        returnSelectedDirection(direcciones[index]);
    }
    
    return (
        <>  
            <RadioButtonGroup
                address
                notificacion
                id="datos-ubicacion-radio-button"
                radioList={direccionesList}
                valueSelected={selected}
                titulo=""
            />
        </>
    )
}
export default DatosUbicacion